import { ParamPatternRegistry } from './ParamPatternRegistry';
import { SearchRouteResolver } from './SearchRouteResolver';
import type { SearchRouteTable } from './SearchRouteTable';

export const createSearchRouteResolvers = (
	tables: SearchRouteTable[],
	patterns: Readonly<Record<string, string | undefined>>,
	prefix: string = ''
): SearchRouteResolver[] => {
	const patternRegistry = new ParamPatternRegistry(patterns);

	return tables.map(table => new SearchRouteResolver(table, patternRegistry, prefix));
};
